/* eslint-disable comma-dangle */
import axios from 'axios';
import qs from 'qs';

const refreshTokenStorageKey = 'refresh_token';
const accessTokenStorageKey = 'access_token';

const auth = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// let timeOffset = 0;

// const getTimeOffset = async function () {
//   const timestampServer = new Date(
//     await auth.get("/timestamp").then((r) => r.data)
//   ).getTime();
//   const timestampClient = Date.now();

//   timeOffset = timestampClient - timestampServer;

//   return timeOffset;
// };

export const getAccessToken = function () {
  return localStorage.getItem(accessTokenStorageKey);
};

const setAccessToken = function (v) {
  if (v == null) {
    localStorage.removeItem(accessTokenStorageKey);
  } else {
    localStorage.setItem(accessTokenStorageKey, v);
  }
};

// const getRefreshToken = function () {
//   return localStorage.getItem(refreshTokenStorageKey);
// };

const setRefreshToken = function (v) {
  if (v == null) {
    localStorage.removeItem(refreshTokenStorageKey);
  } else {
    localStorage.setItem(refreshTokenStorageKey, v);
  }
};

// let payload = jwtDecode(localStorage.getItem(accessTokenStorageKey))

export const requestToken = async function (data) {
  const b4 = Date.now();
  return auth
    .request({
      url: 'oauth/token',
      data: qs.stringify(data),
      method: 'post',
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_OAUTH_CLIENT_KEY}`,
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })
    .then((res) => {
      const now = Date.now();
      localStorage.setItem('auth_timeStamp', new Date());
      if (res.data.expires_in) {
        localStorage.setItem(
          'expires_in',
          res.data.expires_in * 1000 - (now - b4) - 1000
        );
      } else localStorage.setItem('expires_in', 3600000);
      return res.data;
    })
    .catch(() => {
      logout();
    });
};

export const isAuthenticated = function () {
  return getAccessToken() !== null;
};

export const isAuthorized = function () {
  return localStorage.getItem('idProperty') !== null;
};

export const tokenIsExpired = function () {
  const tokenDate = Date.parse(localStorage.getItem('auth_timeStamp'));
  const expiresIn = localStorage.getItem('expires_in');
  return new Date() - tokenDate >= expiresIn;
};

const refreshAccessToken = async function () {
  return requestToken({
    grant_type: 'refresh_token',
    refresh_token: localStorage.getItem(refreshTokenStorageKey),
  }).then((res) => {
    if (res) {
      setAccessToken(res.access_token);
      return localStorage.getItem(accessTokenStorageKey);
    }
  });
};

export const setToken = async function (data) {
  setAccessToken(data.access_token);
  setRefreshToken(data.refresh_token);

  return getAccessToken();
};

export const checkAccessToken = async function () {
  const expired = tokenIsExpired();
  let token = getAccessToken();
  if (expired) {
    token = await refreshAccessToken();
  }
  return token;
};

export const login = async function ({ email, password }) {
  return requestToken({
    grant_type: 'password',
    username: email,
    password,
    // scope: "user",
  })
    .then(async (res) => {
      if (res.access_token && res.refresh_token) {
        const result = await setToken(res);
        return result;
      }
    })
    .catch(() => null);
};

export const loginAdmin = async function ({ email, password }) {
  return requestToken({
    grant_type: 'password',
    username: email,
    password,
    scope: 'admin',
  }).then(async (res) => {
    const result = await setToken(res);
    return result;
  });
};
export const logout2 = async function () {
  if (!getAccessToken()) return null;
  if (!getAccessToken()) return null;
  setAccessToken(null);
  setRefreshToken(null);
  localStorage.clear();
};

export const logout = async function () {
  if (!getAccessToken()) return null;
  setAccessToken(null);
  setRefreshToken(null);
  localStorage.clear();
  window.location = '/';
};
